module.exports = __webpack_public_path__ + "56524edafaca1f2e43c3a2a33cd1bc03.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-17.png
// module id = 2628
// module chunks = 0